import Cookies from 'js-cookie'
import { CookieName } from '@/constants/cookie-name'

export function tokenProvider(): string {
  const token = Cookies.get(CookieName.UserToken)
  return token ? `Bearer ${token}` : ''
}
